export enum TradeType {
  BUY = 'BUY',
  SELL = 'SELL',
}
export enum Input {
  QOUTE = 'qoute',
  BASE = 'base',
}
